import { render, staticRenderFns } from "./playerMarket.vue?vue&type=template&id=8c518b88&scoped=true"
import script from "./playerMarket.vue?vue&type=script&lang=js"
export * from "./playerMarket.vue?vue&type=script&lang=js"
import style0 from "./playerMarket.vue?vue&type=style&index=0&id=8c518b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c518b88",
  null
  
)

export default component.exports